import React from "react";
import { formatPrice } from "./utils/helpers";
export default (props) => {
    const addonItems = props.addons.map((a, index) => (React.createElement("div", { key: index },
        a.title,
        " - ",
        formatPrice(a.price),
        " ",
        a.unit)));
    const hasAddons = addonItems.length > 0;
    const hasPrice = props.price !== null;
    const hasValuation = !hasPrice && !!props.valuation;
    return (React.createElement("div", { className: "cart-body-section" },
        React.createElement("div", { "data-ecom-columnrow": "" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium" }, props.title)),
            hasPrice && (React.createElement("div", { className: "column" },
                formatPrice(props.price),
                " ",
                props.unit))),
        React.createElement("div", null, props.description),
        hasValuation && (React.createElement("div", { className: "text-dark-lighten" },
            "Uppskattat v\u00E4rde:",
            " ",
            formatPrice(Math.round(props.valuation / 100) * 100),
            " ",
            props.unit)),
        hasAddons && React.createElement("div", { className: "m-t-mini" }, addonItems)));
};
